import { Outlet } from 'react-router-dom';
import Nav from './Nav.tsx';

function PageLayout() {
    return (
        <>
            <Nav />
            <main>
                <Outlet />
            </main>
        </>
    );
}

export default PageLayout;
